import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from '../../common/withRouter';
import { Notification, Message } from '../../web.common';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';

// Top-level Events list. Same inline-table styling as AmbassadorApplications
// so the page feels consistent with the rest of the Play admin.
const PlayEventsInternal = (props) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await props.api.playEvents.list();
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setNotification(new Message('error', `Failed to load: ${e?.message || 'unknown'}`));
    } finally {
      setLoading(false);
    }
  }, [props.api]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <Notification newMessage={notification} />
      <PageTop documentTitle='Play events' documentDescription='Curated PLAY events' mainHeadingContent='Play events' />
      <div style={{ padding: 16, color: '#444', maxWidth: 1100 }}>
        <div style={{ marginBottom: 8 }}>
          <Link to='/play' style={{ color: '#666', fontSize: 13 }}>← Back to Play</Link>
        </div>

        {loading ? (
          <p>Loading…</p>
        ) : items.length === 0 ? (
          <p>No events yet. Create one via the API (POST /admin/PlayEvent) — admin form coming soon.</p>
        ) : (
          <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd', textAlign: 'left', background: '#f5f5f5' }}>
                  <th style={{ padding: 10 }}>Event</th>
                  <th style={{ padding: 10 }}>Code</th>
                  <th style={{ padding: 10 }}>Sessions</th>
                  <th style={{ padding: 10 }}>Signups</th>
                  <th style={{ padding: 10 }}>Waitlist</th>
                  <th style={{ padding: 10 }}>Next session</th>
                  <th style={{ padding: 10 }} />
                </tr>
              </thead>
              <tbody>
                {items.map((ev) => (
                  <tr key={ev.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: 10 }}>
                      <div style={{ fontWeight: 600 }}>{ev.nameEn}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>
                        {ev.sport}{ev.affiliationName ? ` · ${ev.affiliationName}` : ''}
                      </div>
                    </td>
                    <td style={{ padding: 10, fontFamily: 'monospace', fontSize: 12 }}>
                      {ev.code}
                      {ev.slug && <div style={{ color: '#999' }}>{ev.slug}</div>}
                    </td>
                    <td style={{ padding: 10 }}>{ev.sessionCount}</td>
                    <td style={{ padding: 10 }}>{ev.totalRegistered} <span style={{ color: '#999' }}>/ {ev.totalCapacity}</span></td>
                    <td style={{ padding: 10 }}>{ev.totalWatchlist}</td>
                    <td style={{ padding: 10 }}>{ev.nextSessionStartsAtUtc ? new Date(ev.nextSessionStartsAtUtc).toLocaleString() : '—'}</td>
                    <td style={{ padding: 10, textAlign: 'right' }}>
                      <Link to={`/play/events/${ev.id}`} style={{ color: '#1a3559' }}>Open ›</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

PlayEventsInternal.propTypes = { api: PropTypes.object.isRequired };

export default connect(() => ({}))(withRouter(withApi(PlayEventsInternal)));
